import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  InteractionsRequest extends  DBObject {  private static readonly _SID: number = 0 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _sid: string = '' ;
 public constructor ( d3eParams ? : Partial<{sid: string}> ) {
 super();

this.setSid(d3eParams?.sid ?? '');
 }
  public get d3eType (  ) : string {
 return 'InteractionsRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get sid (  ) : string {
 return this._sid ; 
 }
  public setSid ( val : string ) : void {
 let isValChanged :boolean=this._sid !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(InteractionsRequest._SID,this._sid);

this._sid=val;

this.fire('sid',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case InteractionsRequest._SID : {
 return this._sid ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : InteractionsRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :InteractionsRequest=( dbObj as InteractionsRequest );

obj.id=this.id;

obj.setSid(this._sid);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case InteractionsRequest._SID : {
 this.setSid(( value as string ));
 break; }
 }
 }
 }